import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { CONFIG, CONFIG_API_BE, URL_AKM } from "../../../../../config";
import { cekCookies } from "../../../../../actions";
import __ from "lodash";
import { Row, Col, Alert, Modal } from "react-bootstrap";
import LoaderModal from "../../../../modal/LoaderModal";
import Navbar from "../../../navbar/Navbar";
import Sidebar from "../../../sidebar/Sidebar";
import accountManagement from "../../../../../apis/accountManagement";
import eduprimeApi from "../../../../../apis/eduprimeApi";
import akmApi from "../../../../../apis/akmApi";
import Select from "react-select";
import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";

class MatapelajaranSnmptn extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            resMessage: "",
            alertShow: false,
            isFetching: false,
        }
    }

    async componentDidMount() {
        console.clear();
        await this.props.cekCookies();
        if (!__.isEmpty(this.props.account)) {
        }
    }

    handleSubmit = async (event) => {
        this.setState({ isFetching: true });

        event.preventDefault();
        if (this.state.file != "" && this.state.file.size < 1000000) {
            let data = new FormData();
            data.append("file", this.state.file);
            const response = await akmApi.post(URL_AKM.IMPORT_MAPEL_SNMPTN, data).catch(function (error) {
                this.setState({ error });
            });

            console.log(response);
            if (response) {
                this.setState({
                    resMessage: response.data.errorSchema,
                    isFetching: false,
                    alertShow: true,
                    keterangan: response.data.data.message,
                });
                document.getElementById("file").value = "";
            }
        } else {
            this.setState({
                keterangan: "File Dokumen harus < 1Mb ..!!",
                alertShow: true,
                isFetching: false,
            });
        }
    };

    onFileChange = (event) => {
        this.setState({
            file: event.target.files[0],
        });
    };

    render() {
        const { isFetching } = this.state;
        return (
            <div className="wrapper">
                <LoaderModal isFetching={isFetching} />
                <Sidebar account={this.props.account} />
                <div id="content" style={{ paddingBottom: "50px" }}>
                    <Navbar />
                    {this.loadAlert()}
                    <div className="row">
                        <div className="col-md-12">
                            <h4>Upload Matapelajaran SNBP</h4>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-5">
                            <div class="card">
                                <div class="card-body">
                                    <form onSubmit={this.handleSubmit}>
                                        <div className="form-group">
                                            <label>
                                                <span className="text-danger">*</span>Pilih File:{" "}
                                            </label>
                                            <input type="file" className="form-control" required onChange={this.onFileChange} id="file" accept=".xlsx" />
                                        </div>
                                        <br />
                                        <button type="submit" value="Submit" className="btn btn-primary">
                                            <li className="fa fa-upload"> Upload</li>
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div class="card">
                                <div class="card-body">
                                    <h5>Prosedur Upload Prodi :</h5>
                                    <ol>
                                        <li>Download format dokumen (.xlsx)&nbsp;</li>
                                        <li>Isi dokumen berdasarkan format yang sudah ditentukan</li>
                                        <li>
                                            Format dokumen wajib&nbsp;
                                            <span class="text-danger">
                                                <strong>*</strong>
                                            </span>
                                            <strong>.xlsx</strong>
                                            <span class="text-danger">
                                                <strong>*</strong>
                                            </span>
                                        </li>
                                        <li>Silahkan isi pada baris ke-3 (bawah warna kuning)</li>
                                        <li>Matapelajaran ini <b>KHUSUS</b> digunakan untuk keperluan SNBP / SNMPTN <u>saja</u>. </li>
                                        <li>PASTIKAN file yang akan di upload sudah sesuai dengan data terbaru.</li>
                                        <br />
                                        <a class="btn btn-info pull-right" href={process.env.PUBLIC_URL + "/UPLOAD_MAPEL_SNMPTN.xlsx"}>
                                            <li className="fa fa-download"> Download</li>
                                        </a>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    loadAlert = () => {
        const { alertShow, keterangan } = this.state;

        if (alertShow) {
            return (
                <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>
                    <strong>{keterangan}</strong>
                </Alert>
            );
        }
    };
}

const mapStateToProps = (state) => {
    return {
        account: state.account,
    };
};

export default connect(mapStateToProps, { cekCookies })(MatapelajaranSnmptn);